import { IconWrapper } from '../runtime';
export default IconWrapper('bold', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M3.25 7.74976H8.75C10.4069 7.74976 11.75 6.40661 11.75 4.74976C11.75 3.0929 10.4069 1.74976 8.75 1.74976H4.75C3.92157 1.74976 3.25 2.42133 3.25 3.24976V7.74976ZM3.25 7.74976H9.5C11.2949 7.74976 12.75 9.20483 12.75 10.9998C12.75 12.7947 11.2949 14.2498 9.5 14.2498H4.75C3.92157 14.2498 3.25 13.5782 3.25 12.7498V7.74976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});